import { render, staticRenderFns } from "./TranquilForestSuite.vue?vue&type=template&id=78459ca7&scoped=true"
import script from "./TranquilForestSuite.vue?vue&type=script&lang=js"
export * from "./TranquilForestSuite.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/roomdetail.css?vue&type=style&index=0&id=78459ca7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78459ca7",
  null
  
)

export default component.exports